var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEEAE8",
  fillRule: "evenodd",
  d: "M147.645 46.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.623-58.698-60.689 1.531-27.357 38.565-27.82 64.193-37.512Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 59,
  r: 2,
  fill: "#FEF0EE"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  d: "M197.59 41.774a5.331 5.331 0 0 0-5.326-5.328 5.326 5.326 0 0 0-5.322 5.328v26.303a95.34 95.34 0 0 0-3.432-.76V34.241a5.327 5.327 0 0 0-10.652 0v30.862c-1.148-.252-2.292-.49-3.429-.712V32.32A5.33 5.33 0 0 0 164.111 27a5.324 5.324 0 0 0-5.326 5.32v30.773c-1.209 0-2.334.104-3.429.279V41.88c0-2.934-2.394-5.315-5.326-5.315a5.317 5.317 0 0 0-5.322 5.315s-.038 36.998-.023 37.816c-.614 5.147-9.883-5.265-18.009-7.474-8.606-2.348-10.785 5.83-2.345 12.517 14.259 11.316 26.574 35.767 26.574 45.154 0 0-.594 14.607 0 17.107.595 2.5 36.107.5 36.851-2 .744-2.5-.551-12.683-.551-12.683 0-8.727 10.385-18.425 10.385-41.7V41.775Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3863F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m128.5 13.5 3.552 21.877M86 53l20.277 3.556M96 20.5l21.174 23.222"
})));
export default SvgArtLogout;